﻿var participantFieldevent = new ParticipantFieldEvent();
var companyname = [];
var surveyLoginEmailAddress = [];
var ExcludedEmailDomainList = [];

$(document).ready(function () {
    getUrlforAPI();
    GetCompanies();
    GetSurveyLoginsEmailAddress();
    getRestrictedEmailDomains();
    $('#resetclick').on('click', function () {
        const companyCode = $("#CompanyCode").val();
        localStorage.setItem('companyCode', companyCode);
        URL = window.location
        const queryString = URL.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('company_code')) {
            setTimeout(function () {
                $('#myForm').find('input[type="text"]').not('#CompanyCode').val('');
                $("#CompanyCode").val(companyCode).attr("disabled", "disabled");
                validateCompanyCode($("#CompanyCode"));
            }, 0);
        }
    });
    $('#associate').click(function () {
        if (ValidateOnAssociateClick() > 0)
        return false;
        $.ajax({
            type: "POST",
            url: localStorage.getItem("fetchURL") + '/api/Registration/Associate/',
            dataType: "json",
            contentType: 'application/json; charset=utf-8',
            processData: false,
            data: JSON.stringify({
                isMember: $("input[name='registered']:checked").val(),
                companyCode: $("#CompanyCode").val()??"",
                companyName: $("#CompanyName").val() ??"",
                regions: $("#Regions").val() ?? "",
                emailAddress: $('#EmailAddress').val() ?? "",
            }),
            success: function (response) {
                response = JSON.parse(response);
                if (response[0] == "Authenticated") {
                    var url = $("#Redirect").val(this.value);
                    window.location.replace(url);
                } else if (response[0] == "AlreadyAssociated") { 
                    var url = $("#Redirect").val(this.value);
                    window.location.replace(url);
                } else {
                    participantFieldevent.SaveAll(response[1]);
                }
            },
            error: function (results) {
                console.log(results);
            }
        });
    });

    $("#EmailAddress").bind("change", function () {
      validateEmail($(this));
      if ($("#EmailAddressConfirm").val() !== "")
        validateEmailConfirm($("#EmailAddressConfirm"));
    });
    $("#EmailAddressConfirm").bind("change", function () {
        return validateEmailConfirm($(this));
    });
    $("#NewPassword").bind("change", function () {
      validatePassword($(this));
      if ($("#ConfirmPassword").val() !== "")
        validateConfirmPassword($("#ConfirmPassword"));
    });
    $("#ConfirmPassword").bind("change", function () {
        return validateConfirmPassword($(this));
    });

    $("#CompanyCode").bind("change", function () {
      return validateCompanyCode($(this));
    });
    $("#CompanyName").bind("change", function () {
      return validateCompanyName($(this));
    });

    $('input[type=reset]').bind("click", function() {
        
        $('*[id*=ErrorMessage]:visible').empty();

        //below 2 line added for temporary Mandatory Terms And Conditions requirement from TE
        if ($.isFunction(window.resetRegistrationWithNameWithBothProcess)){
          resetRegistrationWithNameWithBothProcess();
          return;
        }

        $(".nonmembers").hide();
        $(".members").show();
      });

  $('#Registration').click(function () {
    if (ValidateOnRegisterClick() > 0 )
      return false;
    
        $.ajax({
            type: "POST",
            url: localStorage.getItem("fetchURL") + '/api/Registration/Register/',
            dataType: "json",
            contentType: 'application/json; charset=utf-8',
            processData: false,
            data: JSON.stringify({
                emailAddress: $('#EmailAddress').val() ?? "",
                firstName: $('#FirstName').val() ?? "",
                lastName: $('#LastName').val() ?? "",
                newPassword: $('#NewPassword').val() ?? "",
                companyCode: $('#CompanyCode').val() ?? "",
                companyName: $('#CompanyName').val() ?? "",
                regions: $('#Regions').val() ?? ""
            }),
            success: function (response) {
              var registrationprocess = $("#RegistrationProcess").val();
              if (response == "SUCCESS" && registrationprocess == "BOTH") {
                AssociateUser(response);
              } else if (response == "SUCCESS") {
                $('.successResult').css('display', 'block');
                $('.RegisterForm').css('display', 'none');
              } else if (response != "SUCCESS") {
                $('#register_error').css('display', 'block');
                $('#register_error').html("<strong>" + response + "</strong>");
							}

            },
            error: function (error) {
              alert(error.status + " " + error.statusText);
            }
        });
    });

    $(".nonmembers").hide();
    $(".members").show();

    $(".name1").change(function () {
      $(".regions").show();
      $(".members").hide();
    });
  $('#register_error').hide();


    if ($("#register_error > strong > div.warnings").text().length > 0) {
      $('#register_error').show();
    }
    if ($('.countcheck').length == 1) {
      $('.countcheck').attr("checked", "checked");
      SetRegions();
    }
});


function AssociateUser(response) {
    var data2send = JSON.stringify({
        isMember: $("input[name='registered']:checked").val(),
        companyCode: $("#CompanyCode").val(),
        companyName: $("#CompanyName").val(),
        regions: $("#Regions").val(),
        emailAddress: $('#EmailAddress').val() ?? ""
    });
    var callbacks = {
        OnSuccess: OnParticipantAssociateSuccess,
        OnFailure: OnAssociateFailure,
    };
    var config = new PostConfiguration();
    config.url = localStorage.getItem("fetchURL") + '/api/Registration/Associate/',

        sendRequest(callbacks, config, data2send);
}

function OnParticipantAssociateSuccess(response) {
    if (response.indexOf($('#EmailAddress').val()) > -1) {
        $('#register_error').css('display', 'block');
        $('#register_error').html("<strong>" + response + "</strong>");
    }
    else if (response.indexOf($('#EmailAddress').val()) == -1) {
        response = JSON.parse(response);
        participantFieldevent.SaveAll(response[1]);
    }
}



function OnAssociateFailure(response) {

}


function ParticipantFieldEvent() {
    this.SaveAll = function (USER_ID) {
        var PARTICIPANT_FIELDS = [];
        $('.FieldsSection tr.FieldsSectionRow').each(function (i, row) {
            var currentField = new ParticipantFieldEvent();
            PARTICIPANT_FIELDS.push(currentField.CreateParticipantField($(row), USER_ID));
        });
        var obj = { PARTICIPANT_FIELDS: PARTICIPANT_FIELDS };
        var data2send = JSON.stringify(obj);
        this.SaveService(data2send);
    };

    this.SaveService = function (data2send) {
        var callbacks = {
            OnSuccess: this.OnParticipantSaveSuccess,
            OnFailure: OnFailure,
        };
        var config = new PostConfiguration();
        config.url = localStorage.getItem("fetchURL") + '/api/Registration/Save/',

            sendRequest(callbacks, config, data2send);
    };

    this.OnParticipantSaveSuccess = function (response) {
      var messageBox = new MessageBox();
      if (response.Type.toLowerCase() == "error") {
        $('#register_error').css('display', 'block');
        $('#register_error').html("<strong>" + response.Message.replace("{{emailAddress}}", $('#EmailAddress').val()).replace("{{companyName}}", $('#CompanyName').val()) + "</strong>");
      }
      else if (response.Type.toLowerCase() == "success" && $("input[name='registered']:checked").val() == 'Yes') {
        $('.successResultExistingcompnewuser').css('display', 'block');
        $('.RegisterForm').css('display', 'none');

      } else if (response.Type.toLowerCase() == "success"){
        $('.successResult').css('display', 'block');
        $('.RegisterForm').css('display', 'none');
      }
    };

    this.CreateParticipantField = function ($row, USER_ID) {
        var PARTICIPANT_FIELD = {
            FIELD_NO: $row.find('[id^="FIELD_"]').data("id"),
            USER_ID: USER_ID,
            FIELD_VALUE: this.ParticipantValue($row)
        };
        return PARTICIPANT_FIELD;
    };

    this.ParticipantValue = function ($row) {
        if ($row.find(':radio').length > 0) {
            return $row.find(':radio:checked').val();
        }
        if ($row.find(':checkbox').length > 0) {
            var checkboxValue = '';
            var checkboxOptionsList = $($row.find('.checkboxlist').find(':checkbox:checked'));
            for (var i = 0; i < checkboxOptionsList.length; i++) {
                if (checkboxValue !== '') {
                    checkboxValue += '|';
                }
                checkboxValue += checkboxOptionsList[i].value;
            }
            return checkboxValue;
        }
        return $row.find('[id^="FIELD_"]').val();
    };
}


function appendErrorMessage(control, errorMessage) {
  control.after(function () {
    $('#' + control[0].id + 'ErrorMessage').empty();
    return '<p style="color:red;text-align: left;" id="' + control[0].id + 'ErrorMessage' + '">' + errorMessage + '</p>';
  });
  return false;
}
function ClearErrorMessage(control) {
  $('#' + control[0].id + 'ErrorMessage').empty();
  return true;
}

function ValidateOnAssociateClick() {
    var isValidate = 0;
    if ($('#registered_yes').is(":checked"))
        isValidate += validateCompanyCode($('#CompanyCode')) ? 0 : 1;
    else {
        isValidate += validateCompanyName($("#CompanyName")) ? 0 : 1;
        isValidate += validateRegion($("#Regions")) ? 0 : 1;
    }
    return isValidate;
}


function ValidateOnRegisterClick() {
  var isValidate = 0;

  isValidate += validateEmail($("#EmailAddress")) ? 0 : 1;
  isValidate += validateEmailConfirm($("#EmailAddressConfirm")) ? 0 : 1;
  isValidate += validatePassword($("#NewPassword")) ? 0 : 1;
  if ($("#RegistrationProcess").val().toUpperCase() === "BOTH")
    isValidate +=validateConfirmPassword($("#ConfirmPassword")) ? 0 : 1;

  if ($('#registered_yes').is(":checked") || $("#RegistrationProcess").val().toUpperCase()==="CODE")
    isValidate += validateCompanyCode($('#CompanyCode')) ? 0 : 1;
  else {
    isValidate += validateCompanyName($("#CompanyName")) ? 0 : 1;
    isValidate += validateRegion($("#Regions")) ? 0 : 1;
  }

  //below 2 line added for temporary Mandatory Terms And Conditions requirement from TE
  if ($.isFunction(window.validateMandatoryTermsAndConditions))
    isValidate += validateMandatoryTermsAndConditions($("#TnC table")) ? 0 : 1;

  return isValidate;
}

function validateCompanyName(companyName) {
  if (companyName.val() == "") 
    return appendErrorMessage(companyName, "Enter your Company Name");
  if ($("#RegistrationProcess").val().toUpperCase() === "NAME" || $("#RegistrationProcess").val().toUpperCase() === "BOTH")
    if ($.grep(companyname, function (d) {
      return d.label.toLowerCase() == companyName.val().toLowerCase();
    }).length > 0) 
      return appendErrorMessage(companyName, "Company Name already exist");	

  return ClearErrorMessage(companyName);
  }

function validateRegion(region) {
  if (region.val() == "")
    return appendErrorMessage(region, "Select Region!");
  return ClearErrorMessage(region);
}

function validateCompanyCode(companycode) {
  if (companycode.val() == "") 
    return appendErrorMessage(companycode, "Enter your Company Code.");
  else
  {
    var isCompanyCode = false;
    companyname.forEach(function(company) {
      if (companycode.val().trim() == company.company_code)
        isCompanyCode = true;
    });
    if (!isCompanyCode)
        return appendErrorMessage(companycode, "Company Code does not exist, please contact to administrator.");
    return ClearErrorMessage(companycode);
  }
}


function validateEmail(email) {
  if (email.val() == "")
    return appendErrorMessage(email, "Enter your Email Address.");
  else {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var loginAlreadyExist = $.grep(surveyLoginEmailAddress, function (n, i) { return n.email === email.val() });

    var isExcludedEmailDomain = IsExcludedEmail($(email).val());
    if (loginAlreadyExist.length > 0)
      return appendErrorMessage(email, "The Email you are trying to add already exists.");
    if (!re.test(String(email.val()).toLowerCase()))
      return appendErrorMessage(email, "Email Address is not valid.");
    if (isExcludedEmailDomain)
      return appendErrorMessage(email, $('#EmailDomainValidationMessage').val());
    return ClearErrorMessage(email);
  }
}

function IsExcludedEmail(email) {
  if (email == "" || email == null || email == undefined)
    return false;
  if (ExcludedEmailDomainList == undefined || (ExcludedEmailDomainList.length == 1 && (ExcludedEmailDomainList[0] == "")))
    return false;
  return ExcludedEmailDomainList.some(x => email.includes(x));
}

function validateEmailConfirm(confirmemail) {
  if (confirmemail.val() == "")
    return appendErrorMessage(confirmemail, "Enter your Confirm Email Address.");
  else{
    var email = $('#EmailAddress').val();
    var confemail = confirmemail.val();
    if (email != confemail) 
        return appendErrorMessage(confirmemail, "The Emails entered do not match.");
    return ClearErrorMessage(confirmemail);
  }
}

function validatePassword(password) {
    if (password.val() == "") {
        return appendErrorMessage(password, "Enter your Password.");
    }

    if (password.val().length > 0 && password.val().trim().length === 0) {
        return appendErrorMessage(password, "The Password can't contain only white spaces.");
    }
    return ClearErrorMessage(password);
}


function validateConfirmPassword(confirmpassword) {
  if (confirmpassword.val() == "")
    return appendErrorMessage(confirmpassword, "Enter your Confirm Password.");
  else {
    var password = $('#NewPassword').val();
    var confpassword = confirmpassword.val();
    if (password != confpassword) 
        return appendErrorMessage(confirmpassword, "The Password entered do not match.");
    return ClearErrorMessage(confirmpassword);
  }
}

function ShowSections(radio) {
  if ($(radio).val() == "Yes") {
    $(".members").show();
    $(".nonmembers").hide();
  }
  else {
    $(".members").hide();
    $(".nonmembers").show();
  }
}
function SetRegions() {
  var selectedRegions = "";
  $('.check:checked').each(function () {
    selectedRegions = selectedRegions + $(this).val() + ",";
  });
  $("input[name='Regions']").val(selectedRegions.substring(0, selectedRegions.length - 1));
  validateRegion($("#Regions"));
}

function GetCompanies() {
    var callbacks = {
        OnSuccess: OnGetCompaniesSuccess,
        OnError: OnFailure
    };
    var config = new PostConfiguration();
    config.type = "GET";
    config.url = localStorage.getItem("fetchURL") + '/api/Registration/Companies/';
    sendRequestForLatestVersion(callbacks, config);
}

function OnGetCompaniesSuccess(response) {
    response.forEach(function (company) {
        companyname.push({
            label: company.NAME,
            company_code: company.Company_code
        });
    });
    let registrationprocess = $("#RegistrationProcess").val();
    if (registrationprocess == "BOTH" || registrationprocess == "NAME"){
        AutoCompleteCompanyName(companyname);
    }
    FetchCodeFromUrlAndFillCompanyCode(window.location);
}

function GetSurveyLoginsEmailAddress() {
    var callbacks = {
        OnSuccess: OnGetSurveyLoginsEmailAddressSuccess,
        OnError: OnFailure
    };
    var config = new PostConfiguration();
    config.type = "GET";
    config.url = localStorage.getItem("fetchURL") + '/api/Registration/SurveyLoginsEmailAddress/';
    sendRequestForLatestVersion(callbacks, config);
}

function OnGetSurveyLoginsEmailAddressSuccess(response) {
    response.forEach(function (login) {
        surveyLoginEmailAddress.push({
            email: login.Email,
        });
    });
}

function getRestrictedEmailDomains() {
  var callbacks = {
    OnSuccess: OnGetRestrictedEmailsSucess,
    OnError: OnFailure
  };
  var config = new PostConfiguration();
  config.type = "GET";
  config.url = localStorage.getItem("fetchURL") + '/api/Registration/GetRestrictedEmailList/';
  sendRequestForLatestVersion(callbacks, config);
}

function OnGetRestrictedEmailsSucess(response) {
  ExcludedEmailDomainList = response;
}

function AutoCompleteCompanyName(companyname) {
    $("#CompanyName").autocomplete({
        source: companyname,
        focus: function (event, ui) {
            $("#CompanyName").val(ui.item.label);
            return false;
        },

        select: function (event, ui) {
            $("#CompanyName").val(ui.item.label);
            $("#GeneratedUsername").val(ui.item.value);
            return false;
        }
    })
        .autocomplete("instance")._renderItem = function (ul, item) {
            return $("<li>")
                .append("<div>" + item.label + "</div>")
                .appendTo(ul);
        };
}
function FetchCodeFromUrlAndFillCompanyCode(URL) {
    const queryString = URL.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('company_code')) {
        $("#CompanyCode").val(urlParams.get('company_code')).attr("disabled", "disabled");
        validateCompanyCode($("#CompanyCode"));
    }
}